import { SpanSuccess, SpanDefault } from './index';

const FeatureSpan = ({level}) => {
    if (level === 9) {
        return (
            <SpanSuccess text="有" />
        );
    }
    return (
        <SpanDefault text="無" />
    );
};

export default FeatureSpan;